// Nodes modules
import './modules/@tc';
//import 'classlist-polyfill';
//import 'object-fit-polyfill';

import Packery from 'packery';
import imagesLoaded from 'imagesloaded'; // imagesLoaded en module

//import Swiper, {Navigation, EffectFade, Keyboard} from "swiper"
import Swiper, {Navigation} from "swiper"

import {disablePageScroll, enablePageScroll, adjustScrollbarWidth} from '@fluejs/noscroll';

Swiper.use([Navigation]);

window.addEventListener('load', function() {
    var body = document.body;
    const el = document.querySelector('.my-scrollable-element');
    adjustScrollbarWidth(el);

    // PARRALAX
    const circles = document.querySelectorAll('.parr');

    let currentScroll = 0;
    let targetScroll = 0;

    // --- PARALLAX FLUIDE ---
    function animateParallax() {
        currentScroll += (targetScroll - currentScroll) * 0.1;
        
        circles.forEach((circle, i) => {
            const speed = (i + 1) * 0.01; // vitesses différentes
            const direction = i % 2 === 0 ? -1 : 1; // optionnel : inversion alternée
            const translateY = currentScroll * speed * direction;

            // Si le cercle est visible, on applique aussi la translation
            if (circle.classList.contains('visible')) {
            circle.style.transform = `translate(-50%, ${translateY}px) scale(1)`;
            } else {
            circle.style.transform = `translate(-50%, ${translateY}px) scale(0)`;
            }
        });
        
        requestAnimationFrame(animateParallax);
    }

    window.addEventListener('scroll', () => {
    targetScroll = window.scrollY;
    });

    animateParallax();

    //// HOMEPAGE LETTERS SCROLL APPARITION
    const elements = document.querySelectorAll('.scrolled .cls');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
            entry.target.classList.add('show');
            }
        });
    }, {
        threshold: 0.1
    });

    elements.forEach(el => observer.observe(el));

	//// HEADER TINY
	var scrollPosition = window.scrollY;
	var header = document.getElementById('header');
    const desktop = window.matchMedia('(min-width: 992px)');
    
	window.addEventListener('scroll', function() {
		scrollPosition = window.scrollY;

        if (desktop.matches) {
            if (scrollPosition >= 168) {
                header.classList.add('--tiny');
            } else {
                header.classList.remove('--tiny');
            }
        } else {
            if (scrollPosition >= 60) {
                header.classList.add('--tiny');
            } else {
                header.classList.remove('--tiny');
            }
        }
	});	

    //// NAV MOBILE
    const burgerBtn = document.getElementById('btnBurgerJS');
    
    function toggleMobilMenu() {
        body.classList.toggle("mobilmenu-open");
    }

    function preventTouchScroll(e) {
        e.preventDefault();
    }

    burgerBtn.onclick = function(e) {
        e.preventDefault();
        const isOpen = body.classList.contains('mobilmenu-open');

    if (!isOpen) {
        // 🔒 Bloquer AVANT l’ouverture
        disablePageScroll(el);
        //document.querySelector('.main-html').style.overflow = "hidden";

        document.addEventListener(
            'touchmove',
            preventTouchScroll,
            { passive: false }
        );

        toggleMobilMenu();
    } else {
        toggleMobilMenu();

        enablePageScroll(el);
        //document.querySelector('.main-html').style.overflow = "auto";

        document.removeEventListener(
            'touchmove',
            preventTouchScroll
        );
    }
    };

    //// POPUP CONTACT	
	const buttonContact = document.getElementById('btnContactJS');
    const otherButtonContact = document.getElementById('otherBtnContactJS');

    function exitTimeout() {
        setTimeout(() => {
            body.classList.remove('popup-open');
            body.classList.remove('popup-busy');
        }, "250");
    }
		
    buttonContact.addEventListener('click', function() {
        if (body.classList.contains('popup-open')) { 
            body.classList.add('popup-busy');
            enablePageScroll(el);
            exitTimeout();
        } else {
            body.classList.add('popup-open');
            disablePageScroll(el);
        }
    });
    
    if (otherButtonContact) {
        otherButtonContact.addEventListener('click', function() {
            if (header.classList.contains('scroll-down')) { 
                //header.classList.remove("scroll-down");
            }

            if (body.classList.contains('popup-open')) { 
                body.classList.add('popup-busy');
                //header.style.background = "white";
                enablePageScroll(el);

                exitTimeout();
            } else {
                body.classList.add('popup-open');
                disablePageScroll(el);
            }
        });
    }

    function debounce(fn, delay) {
        let timeout;
        return () => {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay);
        };
    }
    
    const handleResize = debounce(() => {
        if (window.innerWidth <= 991 && body.classList.contains('popup-open')) {
            enablePageScroll(el);
            exitTimeout();
        }

        if (window.innerWidth >= 992 && body.classList.contains('mobilmenu-open')) {
            enablePageScroll(el);
            body.classList.remove("mobilmenu-open");
        }
    }, 100);
    
    window.addEventListener("resize", handleResize);

    // ESC
	document.onkeydown = function(evt) {
		evt = evt || window.event;
		var isEscape = false;
		if ("key" in evt) {
			isEscape = (evt.key === "Escape" || evt.key === "Esc");
		} else {
			isEscape = (evt.keyCode === 27);
		}
		
		if (isEscape) {
			if (body.classList.contains('popup-open')) { 
				body.classList.remove('popup-open');
	
                enablePageScroll(el);
				//document.querySelector('.no-js').style.overflow = "auto";
			}

			var actifButton = document.querySelector('.btn-actif');

			if(actifButton) {
				document.querySelector('.btn-actif').classList.remove('btn-actif');
			}
		}
	};

	// SWIPER TESTIMONIALS
    
    var swiperTestimonyContainer = document.querySelector('.logos-container');

	if(swiperTestimonyContainer) {
		new IntersectionObserver((entries, observer) => {
			if (entries[0].isIntersecting) {
			observer.disconnect()
			
			const swiperTestimony = new Swiper('.logos-container .swiper-container', {
				modules: [Navigation],
				loop: true,
				grabCursor: true,
				//centeredSlides: true,
				slidesPerView: 1,
                slidesPerGroup:1,
                //spaceBetween: 30,
				//autoHeight: true,
                
				navigation: {
					nextEl: ".logos-container .swiper-button-next",
					prevEl: ".logos-container .swiper-button-prev",
				},
                
				breakpoints: {
					576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
					},
					768: {
						slidesPerView: 4,
                        slidesPerGroup:4,
					},
					992: {
						slidesPerView: 5,
                        slidesPerGroup:5,
					},
				},
                
			});
			}
		}).observe(document.querySelector('.logos-container'))
	}
        


    let projectsPackery = null; // instance globale

    // ==============================
    // FILTERS PROJECTS
    // ==============================
    function filtersProjects() {
        const filterLinks = document.querySelectorAll('.bef-link');
        filterLinks.forEach(link => {
            link.addEventListener('click', () => {
                body.classList.add('ajax-trigger');
            });
        });
    }

    // ==============================
    // MASONRY PROJECTS
    // ==============================
    function createProjectsMasonry() {
        const container = document.getElementById('page--realisations');
        if (!container) return;

        const grid = container.querySelector('.projects-wrapper .row');
        if (!grid) return;

        if (window.innerWidth < 768) {
            if (projectsPackery) {
                projectsPackery.destroy();
                projectsPackery = null;
            }
            return;
        }

        // Détruire l'ancienne instance si elle existe
        if (projectsPackery) {
            projectsPackery.destroy();
            projectsPackery = null;
        }

        projectsPackery = new Packery(grid, {
            itemSelector: '.project-card',
            gutter: '.gutter-sizer',
            percentPosition: true
        });

        imagesLoaded(grid, () => {
            projectsPackery.layout();
        });
    }

    // ==============================
    // INIT AU CHARGEMENT
    // ==============================
    filtersProjects();
    createProjectsMasonry();

    // ==============================
    // Drupal AJAX Behavior
    // ==============================
    (function (Drupal) {
        'use strict';

        Drupal.behaviors.ajaxChange = {
            attach(context, settings) {
                filtersProjects();
                createProjectsMasonry();
                body.classList.remove('ajax-trigger');
            }
        };
    })(Drupal);

    // ==============================
    // Animation au chargement
    // ==============================
    setTimeout(() => {
        body.classList.add('loaded');
    }, 500);

    // ==============================
    // Resize dynamique
    // ==============================
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(createProjectsMasonry, 50);
    });

    
    (function() {
        const containerSelector = '.bef-links-use-ajax';
    
        function convertFiltersToSelect(container) {
            if (!container) return;
            const ul = container.querySelector('ul');
            if (!ul) return;
            let existingSelectWrapper = container.querySelector('.news-filters-select');
    
            if (window.innerWidth < 768) {
                if (!existingSelectWrapper) {
                    // Créer le wrapper
                    const wrapper = document.createElement('div');
                    wrapper.className = 'news-filters-select';
    
                    // Créer le titre
                    const title = document.createElement('p');
                    title.className = 'title';
                    title.textContent = 'Filtrer';
    
                    // Créer le select
                    const select = document.createElement('select');
                    select.className = 'bef-link-select';
    
                    ul.querySelectorAll('li a').forEach(link => {
                        const option = document.createElement('option');
                        option.textContent = link.textContent;
                        option.dataset.targetLink = link.id;
                        if (link.classList.contains('bef-link--selected')) {
                            option.selected = true;
                        }
                        select.appendChild(option);
                    });
    
                    select.addEventListener('change', function() {
                        const selectedOption = select.selectedOptions[0];
                        const targetLink = ul.querySelector(`#${selectedOption.dataset.targetLink}`);
                        if (targetLink) targetLink.click();
                    });
    
                    // Ajouter titre + select dans le wrapper
                    wrapper.appendChild(title);
                    wrapper.appendChild(select);
    
                    // Ajouter le wrapper dans le container
                    container.appendChild(wrapper);
    
                    // Masquer la liste originale
                    ul.style.display = 'none';
                }
            } else {
                // Desktop : supprimer wrapper si existant
                if (existingSelectWrapper) {
                    existingSelectWrapper.remove();
                    ul.style.display = '';
                }
            }
        }
    
        // Observer les ajouts au DOM (BEF AJAX)
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) {
                        const container = node.matches(containerSelector) ? node : node.querySelector(containerSelector);
                        if (container) convertFiltersToSelect(container);
                    }
                });
            });
        });
    
        observer.observe(document.body, { childList: true, subtree: true });
    
        // Resize dynamique
        window.addEventListener('resize', () => {
            document.querySelectorAll(containerSelector).forEach(convertFiltersToSelect);
        });
    
        // Au chargement : check si déjà présent
        document.querySelectorAll(containerSelector).forEach(convertFiltersToSelect);
    
    })();
    
    
    
    /*
	// FILTERS PROJECTS
	function filtersProjects() {
		var filterLinks = document.querySelectorAll('.bef-link');

		filterLinks.forEach(filterLink => {
			filterLink.addEventListener('click', function() {
				body.classList.add('ajax-trigger');
			})		  
		});
	}

	filtersProjects();

    
	// MASONRY PROJECTS
	var testProjects = document.getElementById('page--realisations');
	
	function createProjectsMasonry() {
        var testProjects = document.getElementById('page--realisations');
        
        if(testProjects) {

			var grid = document.querySelector('#page--realisations .projects-wrapper .row');

			var pckry = new Packery( grid, {
				itemSelector: '#page--realisations .projects-wrapper .row .project-card',
                gutter: '.gutter-sizer',
                percentPosition: true
			});
        }
	}

	createProjectsMasonry();
	
	(function (Drupal) {
		'use strict';
	  
		Drupal.behaviors.ajaxChange = {
			attach (context, settings) {
				filtersProjects();
				createProjectsMasonry();
				body.classList.remove('ajax-trigger');
			}
		};
	} (Drupal));

    setTimeout(() => {
        body.classList.add('loaded');
    }, "500");
    */


    //// SECTIONS APPEAR SCROLL    
    //// Scroll Animation
    var sections = document.querySelectorAll('.section');

    function myFunction(x) { 
        //console.log(x.matches); // Vérifie la valeur de matches en ligne
        
        var options = {
          rootMargin: '0px',
          threshold: x.matches ? 0.2 : 0.7
        };
    
        var callback = (entries) => {
          entries.forEach((entry) => {
            var target = entry.target;
            if (entry.intersectionRatio >= (x.matches ? 0.2 : 0.7)) {
              target.classList.add("is-inview");
            }
          });
        };
    
        var observer = new IntersectionObserver(callback, options);
        sections.forEach((section) => {
          observer.observe(section);
        });
    }
    
    
    // Create a MediaQueryList object
    var x = window.matchMedia("(max-height: 1199px)");
    
    // Call listener function at run time
    myFunction(x);
    
    // Attach listener function on state changes
    x.addEventListener("change", function() {			
        myFunction(x);
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
        const animElements = document.querySelectorAll(
            '.jumbotron.--homepage .element img, .jumbotron.--homepage h1 span, .jumbotron.--homepage .element svg, .jumbotron.--intern h1'
          );
    animElements.forEach(el => el.classList.add('no-transition'));

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        animElements.forEach(el => el.classList.remove('no-transition'));
    }, 150);
    });
});